import type { InventoryItemCategoryEdit } from 'types';
import { Api } from '../fetch';

export const inventoryCategoryNet = {
  get: (archived?: boolean) => Api.get<'inventoryCategory', 'get'>('/inventory/categories', { query: { archived } }),
  getById: (id: string) => Api.get<'inventoryCategory', 'getById'>(`/inventory/category/:id`, { params: { id } }),
  /** @access inventory manager */
  upsert: (body: InventoryItemCategoryEdit) => Api.post<'inventoryCategory', 'upsert'>('/inventory/category', { body }),
  /** @access inventory manager */
  archive: (id: string) => Api.delete<'inventoryCategory', 'archive'>('/inventory/category/:id', { params: { id } }),
  /** @access inventory manager */
  restore: (id: string) =>
    Api.patch<'inventoryCategory', 'restore'>('/inventory/category/:id/restore', { params: { id } }),
};
